import { styled, useTheme } from '@vebox/etui-system';
import { createElement, Fragment } from 'react';
import { b as _extends } from '../../_rollupPluginBabelHelpers-3b7bd988.js';
import { Span, Div } from '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import Icon from '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';

const GroupTitleText = styled(Span)`
  line-height: 1.6rem;
  font-weight: ${({
  theme
}) => theme.typography.fontWeightBold};
  color: ${({
  theme
}) => theme.palette.grey[60]};
  letter-spacing: 0.6px;
  margin-right: ${({
  theme
}) => theme.spacing.xs}px;
`;

const GroupTitleWrapper = styled(Div)`
  height: 28px;
  display: flex;
  align-items: center;
`;

const GroupItemsWrapper = styled(Div)`
  display: flex;
  flex-wrap: wrap;
  margin: ${({
  theme
}) => theme.spacing.lg}px 0;
  row-gap: ${({
  theme
}) => theme.spacing.md}px;
  column-gap: ${({
  theme
}) => theme.spacing.md}px;
`;

const Group = ({
  title,
  iconProps,
  children
}) => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(GroupTitleWrapper, null, /*#__PURE__*/createElement(GroupTitleText, null, title), !!iconProps && /*#__PURE__*/createElement(Icon, _extends({
    size: 16,
    styles: {
      root: {
        color: theme.palette.grey[60]
      }
    }
  }, iconProps))), /*#__PURE__*/createElement(GroupItemsWrapper, null, children));
};

export default Group;
